//import React, { useState } from 'react';
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
  Stack,
  Container,
  Text,
  Badge,
  VStack,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import SessionFlowTrigger from '../components/sessionflow/SessionFlowTrigger';
import CTAButton from './CTAButton';
import { useAnalytics } from '../hooks/useAnalytics';

//import {useAppData} from '../store/dataStore';

const Navbar = () => {
  const { trackEvent } = useAnalytics();

  //const { appData } = useAppData();
  //const { studentsCount } = appData;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();

  return (
    <Box
      bg="rgba(255, 255, 255, 0.95)"
      backdropFilter="blur(10px)"
      px={4}
      position="sticky"
      top={0}
      zIndex={1000}
      boxShadow="0 2px 20px rgba(0,0,0,0.05)"
    >
      <Container maxW="container.xl">
        <Flex h={20} alignItems="center" justifyContent="space-between">
          {/* Logo */}
          <Box
            as={RouterLink}
            to="/"
            _hover={{ opacity: 0.8 }}
            transition="opacity 0.2s"
            display="flex"
            alignItems="center"
          >
            <Box>
              <HStack>
              <img src="https://images.ojasamirai.com/ojasa/common/logo.png" alt="Ojasa Mirai Logo" style={{ width: '80px', height: '100%', objectFit: 'contain' }} />
              <VStack alignItems="left">
              <Text
                fontSize="2xl"
                fontWeight="900"
                bgGradient="linear(to-r, brand.700, accent.green)"
                bgClip="text"
                fontFamily="heading"
              >
                Ojasa Mirai
              </Text>
              <Text fontSize="xs" color="brand.500" mt={-1}>GenAI Training</Text>
              </VStack>
              </HStack>
            </Box>
          </Box>

          {/* Desktop Menu */}
          <HStack spacing={8} display={{ base: 'none', md: 'flex' }}>
            <Menu>
              <MenuButton
                as={Button}
                variant="ghost"
                rightIcon={<ChevronDownIcon />}
                color="brand.700"
                fontWeight="600"
                _hover={{ bg: 'brand.50' }}
              >
                Programs
              </MenuButton>
              <MenuList>
                <MenuItem
                  onClick={() => navigate('/beginner-track')}
                  _hover={{ bg: 'accent.green', color: 'white' }}
                  position="relative"
                >
                  <Box>
                    <HStack spacing={2}>
                      <Text fontWeight="600">Beginner Track</Text>
                      <Badge
                        colorScheme="green"
                        fontSize="xs"
                        px={2}
                        py={0.5}
                        borderRadius="full"
                      >
                        Most Popular
                      </Badge>
                    </HStack>
                    <Text fontSize="xs" color="brand.500" mt={1}>
                      24 Weeks • Zero to GenAI Developer
                    </Text>
                  </Box>
                </MenuItem>
                <MenuItem
                  onClick={() => navigate('/experienced-track')}
                  _hover={{ bg: 'brand.50' }}
                >
                  <Box>
                    <Text fontWeight="600">Experienced Track</Text>
                    <Text fontSize="xs" color="brand.500" mt={1}>
                      8 Weeks • Advanced GenAI & LLMs
                    </Text>
                  </Box>
                </MenuItem>
                <MenuItem
                  onClick={() => navigate('/ai-mastery')}
                  _hover={{ bg: 'brand.50' }}
                >
                  <Box>
                    <HStack spacing={2}>
                      <Text fontWeight="600">Elite AI Engineering</Text>
                      <Badge
                        colorScheme="purple"
                        fontSize="xs"
                        px={2}
                        py={0.5}
                        borderRadius="full"
                      >
                        New
                      </Badge>
                    </HStack>
                    <Text fontSize="xs" color="brand.500" mt={1}>
                      15 days • Only weekend classes • AI-Augmented Engineering
                    </Text>
                  </Box>
                </MenuItem>
              </MenuList>
            </Menu>

            <Button
              as={RouterLink}
              to="/why-us"
              variant="ghost"
              color="brand.700"
              fontWeight="600"
              _hover={{ bg: 'brand.50' }}
            >
              Why Us
            </Button>

            {/*<Button 
              as={RouterLink}
              to="/success-stories"
              variant="ghost" 
              color="brand.700" 
              fontWeight="600"
              _hover={{ bg: 'brand.50' }}
            >
              Success Stories
            </Button>
            
            <Button 
              as={RouterLink}
              to="/blog"
              variant="ghost" 
              color="brand.700" 
              fontWeight="600"
              _hover={{ bg: 'brand.50' }}
            >
              Resources
            </Button>*/}


            <Button
              as={RouterLink}
              to="/contact"
              variant="ghost"
              color="brand.700"
              fontWeight="600"
              _hover={{ bg: 'brand.50' }}
            >
              Contact
            </Button>
          </HStack>

          {/* CTA Buttons */}
          <HStack spacing={4} display={{ base: 'none', md: 'flex' }}>
            <CTAButton to="/webinar" variant="outline" size="md" colorScheme="green" 
            onClick={() => trackEvent('cta_click', {
      page: 'home',
      section: 'footer',
      cta_label: 'join_free_webinar'
    }) }
            >Free Webinar</CTAButton>
            <SessionFlowTrigger
              buttonText="Experience"
              variant="solid"
              size="md"
              colorScheme="green"
              
            />
          </HStack>

          <HStack spacing={4} display={{ base: 'none', md: 'flex' }}>

            <CTAButton href="https://portal.ojasamirai.com/login" variant="outline" size="md">Login</CTAButton>

          </HStack>

          {/* Mobile menu button */}
          <IconButton
            size="md"
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label="Open Menu"
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
            variant="ghost"
            color="brand.700"
          />
        </Flex>

        {/* Mobile Menu */}
        {isOpen && (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as="nav" spacing={4}>
              {/* Programs Section */}
              <Box>
                <Text
                  fontSize="xs"
                  fontWeight="700"
                  color="brand.500"
                  mb={2}
                  textTransform="uppercase"
                >
                  Programs
                </Text>
                <Stack spacing={2} pl={2}>
                  <Button
                    as={RouterLink}
                    to="/beginner-track"
                    variant="ghost"
                    w="full"
                    justifyContent="flex-start"
                    onClick={onClose}
                    position="relative"
                  >
                    <HStack spacing={2} w="full">
                      <Text>Beginner Track</Text>
                      <Badge
                        colorScheme="green"
                        fontSize="2xs"
                      >
                        Popular
                      </Badge>
                    </HStack>
                  </Button>
                  <Button
                    as={RouterLink}
                    to="/experienced-track"
                    variant="ghost"
                    w="full"
                    justifyContent="flex-start"
                    onClick={onClose}
                  >
                    Experienced Track
                  </Button>
                  <Button
                    as={RouterLink}
                    to="/ai-mastery"
                    variant="ghost"
                    w="full"
                    justifyContent="flex-start"
                    onClick={onClose}
                  >
                    <HStack spacing={2} w="full">
                      <Text>Elite AI Engineering</Text>
                      <Badge
                        colorScheme="purple"
                        fontSize="2xs"
                      >
                        New
                      </Badge>
                    </HStack>
                  </Button>
                </Stack>
              </Box>

              <Button
                as={RouterLink}
                to="/why-us"
                variant="ghost"
                w="full"
                justifyContent="flex-start"
                onClick={onClose}
              >
                Why Us
              </Button>
              {/*<Button 
                as={RouterLink}
                to="/success-stories"
                variant="ghost" 
                w="full" 
                justifyContent="flex-start"
                onClick={onClose}
              >
                Success Stories
              </Button> 
              <Button 
                as={RouterLink}
                to="/blog"
                variant="ghost" 
                w="full" 
                justifyContent="flex-start"
                onClick={onClose}
              >
                Resources
              </Button>*/}
              <Button
                as={RouterLink}
                to="/contact"
                variant="ghost"
                w="full"
                justifyContent="flex-start"
                onClick={onClose}
              >
                Contact
              </Button>

              {/* Mobile CTAs */}
              <Box pt={4} borderTop="1px solid" borderColor="brand.100">
                <Stack spacing={3}>
                  <CTAButton to="/webinar" variant="outline" w="full">Free Webinar</CTAButton>
                  <SessionFlowTrigger
                    buttonText="Experience"
                    variant="solid"
                    size="md"
                    colorScheme="green"
                  />

                  <CTAButton href="https://portal.ojasamirai.com/login" variant="outline" w="full">Students Login</CTAButton>

                </Stack>
              </Box>

            </Stack>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Navbar;
